import { track } from '@vercel/analytics';

export function trackEvent(name, properties = {}) {
  try {
    if (typeof window === 'undefined') return;
    track(name, properties);
  } catch {
    // ignore
  }
}
